import React, { ReactNode } from "react";

interface RenderIfProps {
  children: ReactNode;
  shouldRender?: boolean;
}

const RenderIf = ({ children, shouldRender }: RenderIfProps) => {
  return shouldRender ? <>{children}</> : null;
};

export default RenderIf;
